import { z } from 'zod';
import { AIValidatedQuestionType } from '../common/question';
import { HttpErrorResponse } from '../common/validation-error';
/** Validate a single answer in CMS preview, without a persisted submission. */
export const PreviewValidateAnswerBody = z.object({
    questionText: z.string().min(1),
    questionNotes: z.string(),
    questionType: AIValidatedQuestionType,
    modelAnswer: z.string().nullable(),
    userAnswer: z.string(),
});
export const PreviewValidateAnswerResponse = z.object({
    result: z.string().nullable(),
    review: z.string().nullable(),
    isCorrect: z.boolean().nullable(),
    doesSatisfyAllRequirements: z.boolean().nullable(),
});
export const previewValidateAnswerRoute = {
    version: 1,
    method: 'POST',
    path: '/admin/cms/preview/validate-answer',
    name: 'preview-validate-answer',
    request: { body: PreviewValidateAnswerBody },
    responses: {
        200: PreviewValidateAnswerResponse,
        400: HttpErrorResponse,
    },
};
